export function fillMissingDays(data, startDate = null, endDate = null) {
  function parseDate(dateStr) {
    return new Date(dateStr);
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function addDays(date, numDays) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + numDays);
    return newDate;
  }

  // Parse the startDate and endDate if provided
  const parsedStartDate = startDate
    ? parseDate(startDate)
    : parseDate(data[0]?.[0]);
  const parsedEndDate = endDate ? parseDate(endDate) : new Date();

  const augmentedData = [];

  // If the data array is empty, fill in the range with empty elements
  if (data.length === 0) {
    let currentDate = parsedStartDate;
    while (currentDate <= parsedEndDate) {
      augmentedData.push([
        formatDate(currentDate),
        0,
        0,
        0,
        0,
        0,
        0, // default values for clicks, buttons, etc.
      ]);
      currentDate = addDays(currentDate, 1);
    }
    return augmentedData;
  }

  let canceledClicks = 0;
  let clicksToPay = 0;
  let previousTotalClicks = 0;
  let previousTotalButtons = 0;

  // Handle data augmentation based on the existing entries
  for (let i = 0; i < data.length; i++) {
    const currentEntryDate = parseDate(data[i][0]);

    // If the current date is before the specified startDate, skip it
    if (currentEntryDate < parsedStartDate) {
      continue;
    }

    // Push the current entry into augmentedData
    augmentedData.push(data[i]);

    canceledClicks = data[i][10];
    clicksToPay = data[i][11];
    previousTotalClicks = data[i][12];
    previousTotalButtons = data[i][13];

    // If it's not the last element in the data array, fill missing days between the entries
    if (i < data.length - 1) {
      let nextEntryDate = parseDate(data[i + 1][0]);

      while (addDays(currentEntryDate, 1) < nextEntryDate) {
        currentEntryDate.setDate(currentEntryDate.getDate() + 1);

        // If the current date exceeds the endDate, stop filling
        if (currentEntryDate > parsedEndDate) {
          break;
        }

        augmentedData.push([
          formatDate(currentEntryDate),
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          canceledClicks,
          clicksToPay,
          previousTotalClicks,
          previousTotalButtons,
        ]);
      }
    }
  }

  // Add missing days from the last data entry up to endDate (or today)
  let lastEntryDate = parseDate(augmentedData[augmentedData.length - 1][0]);

  while (lastEntryDate <= parsedEndDate) {
    lastEntryDate = addDays(lastEntryDate, 1);

    if (lastEntryDate > parsedEndDate) {
      break;
    }

    augmentedData.push([
      formatDate(lastEntryDate),
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      canceledClicks,
      clicksToPay,
      previousTotalClicks,
      previousTotalButtons,
    ]);
  }

  return augmentedData;
}

// Example usage:
// const data = [];

// console.log(fillMissingDays(data, "2024-09-08", "2024-09-14"));
